import Ajv from 'ajv';

import {
  setIsLoadingGet,
  setIsLoadingPost,
  setIsLoadingPatch,
  setSuccess,
  setError,
  setEncryptedQuoteId,
  setDataField
} from './abandoned-cart-slice';
import {
  patchQuoteLeadById,
  postQuoteLead,
  getQuoteLeadById
} from 'api/quote-lead';
import { getErrors } from 'api/client';
import { SchemaValidationError } from 'errors/SchemaValidationError';

import abandonedCartRequestPayloadSchema from 'api/schemas/abandoned-cart-request-payload-schema.json';
import { AbandonedCartStatus } from './types/abandoned-cart.js';

const ajv = new Ajv({ strict: false });

export const postAbandonedCartThunk = (payload) => async (dispatch) => {
  const isValidPayload = ajv.validate(
    abandonedCartRequestPayloadSchema,
    payload
  );

  if (!isValidPayload) {
    const error = new SchemaValidationError({
      message: '',
      payload,
      schema: abandonedCartRequestPayloadSchema,
      ajvErrors: ajv.errors
    });
    const errors = [error.toJson()];

    dispatch(setError(errors));
    throw error;
  }

  try {
    dispatch(setIsLoadingPost());
    const response = await postQuoteLead(payload);
    dispatch(setEncryptedQuoteId(encodeURIComponent(response.encryptedID)));
    dispatch(setSuccess(payload));
    dispatch(
      setDataField({
        name: 'status',
        value: AbandonedCartStatus.INPROGRESS
      })
    );
    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};

export const patchAbandonedCartThunk = (payload, encryptedId) => async (
  dispatch
) => {
  const isValidPayload = ajv.validate(
    abandonedCartRequestPayloadSchema,
    payload
  );
  if (!isValidPayload) {
    const error = new SchemaValidationError({
      message: '',
      payload,
      schema: abandonedCartRequestPayloadSchema,
      ajvErrors: ajv.errors
    });
    const errors = [error.toJson()];

    dispatch(setError(errors));
    throw error;
  }

  try {
    dispatch(setIsLoadingPatch());
    const response = await patchQuoteLeadById(payload, encryptedId);
    dispatch(setEncryptedQuoteId(encodeURIComponent(response.encryptedID)));
    dispatch(setSuccess(payload));
    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};

export const getAbandonedCartThunk = (encryptedId) => async (dispatch) => {
  try {
    dispatch(setIsLoadingGet());
    const response = await getQuoteLeadById(encryptedId);
    dispatch(setSuccess(response));

    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};
